import Vue from 'vue'

// State
const state = {
  isLoading: false,
  isSaving: false,
  data: null
}

// Mutations
const fetchExhibitionRequest = 'fetchExhibitionRequest'
const fetchExhibitionResponse = 'fetchExhibitionResponse'
export const updateExhibition = 'updateExhibition'
export const resetExhibition = 'resetExhibition'

const mutations = {
  [fetchExhibitionRequest] (state) {
    state.isLoading = true
  },
  [fetchExhibitionResponse] (state, exhibition) {
    state.isLoading = false
    state.data = exhibition
  },
  [updateExhibition] (state, changes) {
    state.data = { ...state.data, ...changes }
  },
  [resetExhibition] (state) {
    state.data = null
    state.isLoading = false
  }
}

// Actions
export const fetchExhibition = 'fetchExhibition'
export const saveExhibition = 'saveExhibition'
const actions = {
  [fetchExhibition]: ({ commit, dispatch }, { id }) => {
    commit(fetchExhibitionRequest)
    return Vue.http
      .get(`${SERVER_URL}/exhibitions/${id}`)
      .then(({ data: exhibition }) => {
        commit(fetchExhibitionResponse, exhibition)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/exhibition.js